window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function (timeOutFn) {
    return setTimeout(timeOutFn, 1000 / 60);
  };
window["CP_SP_Sitewide_06"] = function () {
  if (typeof jQuery == 'function' && document.querySelectorAll('ul.menu-drawer__menu a[href*="/collections/"]').length>0 && document.querySelectorAll('.CP_SP_Sitewide_06').length == 0 && window.innerWidth <768) {
     jQuery('body').addClass('CP_SP_Sitewide_06');

     jQuery('a#HeaderDrawer-home').parent().remove();
 
     jQuery('a#HeaderDrawer-all-collections').addClass('imgBx').prepend('<img src="https://useruploads.vwo.io/useruploads/1120839/images/78098f77839850b50eb08796fa403329_allcollections.png">');
     jQuery('a#HeaderDrawer-all-collections').closest('li').addClass('halfLi');

     jQuery('summary#HeaderDrawer-shop-by-bike').addClass('imgBx').prepend('<img src="https://useruploads.vwo.io/useruploads/1120839/images/426b48b767ad88fa2301c5e3e4ad98e1_shopbike.png">');
     jQuery('summary#HeaderDrawer-shop-by-bike').closest('li').addClass('halfLi');

     jQuery('summary#HeaderDrawer-shop-by-spares').addClass('imgBx').prepend('<img src="https://useruploads.vwo.io/useruploads/1120839/images/f28985467cac4955454f1b45b151d569_sparepart.png">');
     jQuery('summary#HeaderDrawer-shop-by-spares').closest('li').addClass('halfLi');

     jQuery('summary#HeaderDrawer-shop-by-accessories').addClass('imgBx').prepend('<img src="https://useruploads.vwo.io/useruploads/1120839/images/7470e632065864137bd70c14704e4ac5_shopacc.png">');
     jQuery('summary#HeaderDrawer-shop-by-accessories').closest('li').addClass('halfLi');

    jQuery('a#HeaderDrawer-wholesale-price').prepend('<img src="https://useruploads.vwo.io/useruploads/1120839/images/9c650ca1e1f8b7df4ac7d8d28d58a452_wholesaleprice.png">');
    jQuery('a#HeaderDrawer-wholesale-price').closest('li').addClass('iconBx');

    jQuery('a#HeaderDrawer-track-order').prepend('<img src="https://useruploads.vwo.io/useruploads/1120839/images/461aafca67d102e23d2e766423187bba_trackorder.png">');
    jQuery('a#HeaderDrawer-track-order').closest('li').addClass('iconBx');

    jQuery('a#HeaderDrawer-return-and-replacement').prepend('<img src="https://useruploads.vwo.io/useruploads/1120839/images/92a5b3319b6c01fb38729589474a2de6_returnandreplacement.png">');
    jQuery('a#HeaderDrawer-return-and-replacement').closest('li').addClass('iconBx');

    jQuery('a#HeaderDrawer-contact-us').prepend('<img src="https://useruploads.vwo.io/useruploads/1120839/images/e3d2f30063cea1165b6bce381c3d16e1_contantus.png">');
    jQuery('a#HeaderDrawer-contact-us').closest('li').addClass('iconBx');

    jQuery('a#HeaderDrawer-faq').prepend('<img src="https://useruploads.vwo.io/useruploads/1120839/images/efe59b371b3b8b4a9bf52ab5e81cc26d_faq.png">');
    jQuery('a#HeaderDrawer-faq').closest('li').addClass('iconBx');

    jQuery('a#HeaderDrawer-blog').prepend('<img src="https://useruploads.vwo.io/useruploads/1120839/images/53560de4fe488a4d32cf4c80ac8ee37e_blog.png">');
    jQuery('a#HeaderDrawer-blog').closest('li').addClass('iconBx');

    jQuery('a#HeaderDrawer-wishlist').prepend('<img src="https://useruploads.vwo.io/useruploads/1120839/images/927abca02fda749a216a1d2712341710_wishlist.png">');
    jQuery('a#HeaderDrawer-wishlist').closest('li').addClass('iconBx');
     
    jQuery('summary#HeaderDrawer-shop-by-bike-ktm').html('<img src="https://useruploads.vwo.io/useruploads/1120839/images/f6f9ad039d185665258db3066a280a1e_ktm.png" class="brandLogo">');
    jQuery('summary#HeaderDrawer-shop-by-bike-ktm').closest('li').addClass('logoBx');

    jQuery('summary#HeaderDrawer-shop-by-bike-husqvarna').html('<img src="https://useruploads.vwo.io/useruploads/1120839/images/c4a4ecdc6a6abccb88791a120ed51e6c_husq.png" class="brandLogo">');
    jQuery('summary#HeaderDrawer-shop-by-bike-husqvarna').closest('li').addClass('logoBx');

    jQuery('summary#HeaderDrawer-shop-by-bike-bajaj').html('<img src="https://useruploads.vwo.io/useruploads/1120839/images/46e14a738b049d075e414591cbce4fc3_bajaj.png" class="brandLogo">');
    jQuery('summary#HeaderDrawer-shop-by-bike-bajaj').closest('li').addClass('logoBx');

    jQuery('summary#HeaderDrawer-shop-by-bike-tvs').html('<img src="https://useruploads.vwo.io/useruploads/1120839/images/6126c5d4f13b6118dd3f511d20de3c4c_tvs.png" class="brandLogo tvsLogo">');
    jQuery('summary#HeaderDrawer-shop-by-bike-tvs').closest('li').addClass('logoBx');

    jQuery('summary#HeaderDrawer-shop-by-bike-royal-enfield').html('<img src="https://useruploads.vwo.io/useruploads/1120839/images/8431104498151705943ff8756937b561_royalenfield.png" class="brandLogo">');
    jQuery('summary#HeaderDrawer-shop-by-bike-royal-enfield').closest('li').addClass('logoBx');

    jQuery('summary#HeaderDrawer-shop-by-bike-kawasaki').html('<img src="https://useruploads.vwo.io/useruploads/1120839/images/ccc7277284c193d974db7b666c14fa43_kawasaki.png" class="brandLogo">');
    jQuery('summary#HeaderDrawer-shop-by-bike-kawasaki').closest('li').addClass('logoBx');

    jQuery('summary#HeaderDrawer-shop-by-bike-benelli').html('<img src="https://useruploads.vwo.io/useruploads/1120839/images/9dc70a21415ce95a00d78d148b92f792_benelli.png" class="brandLogo">');
    jQuery('summary#HeaderDrawer-shop-by-bike-benelli').closest('li').addClass('logoBx');

    jQuery('summary#HeaderDrawer-shop-by-bike-yamaha').html('<img src="https://useruploads.vwo.io/useruploads/1120839/images/ac6925270c9db472d384a045d8bc40a9_yamaha.png" class="brandLogo">');
    jQuery('summary#HeaderDrawer-shop-by-bike-yamaha').closest('li').addClass('logoBx');

    jQuery('summary#HeaderDrawer-shop-by-bike-piaggio').html('<img src="https://useruploads.vwo.io/useruploads/1120839/images/48127d5682b75e9ab345706b10d91a72_piaggio.png" class="brandLogo">');
    jQuery('summary#HeaderDrawer-shop-by-bike-piaggio').closest('li').addClass('logoBx');

    jQuery('summary#HeaderDrawer-shop-by-bike-bmw').html('<img src="https://useruploads.vwo.io/useruploads/1120839/images/ee9b5ce8155d8043319c2dfc796303e9_bmw.png" class="brandLogo">');
    jQuery('summary#HeaderDrawer-shop-by-bike-bmw').closest('li').addClass('logoBx');

    jQuery('summary#HeaderDrawer-shop-by-bike-hero').html('<img src="https://useruploads.vwo.io/useruploads/1120839/images/710c5a32340404f19a56953122c8e969_hero.png" class="brandLogo heroLogo">');
    jQuery('summary#HeaderDrawer-shop-by-bike-hero').closest('li').addClass('logoBx');

    jQuery('summary#HeaderDrawer-shop-by-bike-ducati').html('<img src="https://useruploads.vwo.io/useruploads/1120839/images/b7badffef6432fc5880c934668c856a7_ducati.png" class="brandLogo">');
    jQuery('summary#HeaderDrawer-shop-by-bike-ducati').closest('li').addClass('logoBx');

    jQuery('summary#HeaderDrawer-shop-by-bike-honda').html('<img src="https://useruploads.vwo.io/useruploads/1120839/images/0389ec8c15316f86e9cb7777045fd1e5_honda.jpg" class="brandLogo hondaLogo">');
    jQuery('summary#HeaderDrawer-shop-by-bike-honda').closest('li').addClass('logoBx');

    jQuery('a#HeaderDrawer-shop-by-bike-ola').html('<img src="https://useruploads.vwo.io/useruploads/1120839/images/4b043222697dc673a336a0ff1971d6a5_ola.png" class="brandLogo">');
    jQuery('a#HeaderDrawer-shop-by-bike-ola').closest('li').addClass('logoBx');

    jQuery('a#HeaderDrawer-shop-by-bike-harley-davidson').html('<img src="https://useruploads.vwo.io/useruploads/1120839/images/4026573001802d0d4f8b36304d43c864_harley.png" class="brandLogo">');
    jQuery('a#HeaderDrawer-shop-by-bike-harley-davidson').closest('li').addClass('logoBx');

    jQuery('a#HeaderDrawer-shop-by-bike-suzuki').html('<img src="https://useruploads.vwo.io/useruploads/1120839/images/b1f73dbc06c751bd8366962a7c2a04fc_suzuki.png" class="brandLogo">');
    jQuery('a#HeaderDrawer-shop-by-bike-suzuki').closest('li').addClass('logoBx');

    jQuery('a#HeaderDrawer-shop-by-bike-triumph').html('<img src="https://useruploads.vwo.io/useruploads/1120839/images/074e709e4d9d87823ad9d7f7797a8afa_triumph.png" class="brandLogo">');
    jQuery('a#HeaderDrawer-shop-by-bike-triumph').closest('li').addClass('logoBx');

    jQuery('a#HeaderDrawer-shop-by-bike-ather').html('<img src="https://useruploads.vwo.io/useruploads/1120839/images/4b9a370e8a7c7f32f81d4cbd25923628_screenshot20250904at1.24.48pm.png" class="brandLogo">');
    jQuery('a#HeaderDrawer-shop-by-bike-ather').closest('li').addClass('logoBx');

document.addEventListener("click", function (event) {
    const selectors = ["div#menu-drawer a"];

    for (let selector of selectors) {
        const matchedElement = event.target.closest(selector);
        localStorage.setItem("interactMenuItems", "1");
    }
});

document.addEventListener("click", function (event) {
  if(localStorage.getItem("interactMenuItems") == "1"){
        if (event.target.matches("button.product-form__submit")) {
            window.VWO = window.VWO || [];
            VWO.event = VWO.event || function () {VWO.push(['event'].concat([].slice.call(arguments)))};
            VWO.event('menuClickAddToCart')

            localStorage.removeItem("interactMenuItems");
        }
        if (event.target.matches(".quick-add__submit")) {
            window.VWO = window.VWO || [];
            VWO.event = VWO.event || function () {VWO.push(['event'].concat([].slice.call(arguments)))};
            VWO.event('menuClickAddToCart')

            localStorage.removeItem("interactMenuItems");
        }
  }
});    


  } else if (!document.body.classList.contains("CP_SP_Sitewide_06")) {
    window.requestAnimationFrame(window.CP_SP_Sitewide_06);
  }
};
window.CP_SP_Sitewide_06();
